export default __webpack_public_path__ + "static/media/icon-family.8e5dc551.svg";